import * as yup from 'yup';
import { SitesLocalePrefix } from '../../../enums';
import { useTranslation } from '@centric-os/helpers';
import { type Shape, type Device as VolanteDevice } from '@centric-os/types';

export default (siteNames: string[]) => {
  const { translate } = useTranslation();
  const LOCALE_PREFIX = SitesLocalePrefix.STATION_INTEGRATIONS;

  const schema = yup.object<Shape<VolanteDevice>>({
    business_units: yup
      .array()
      .of(yup.string())
      .min(
        1,
        translate(`errorMessages.minValue`, {
          minValue: '1',
          record: 'business unit',
        }),
      )
      .required(translate(`errorMessages.required`)),
    site_device_id: yup.string().required(translate(`errorMessages.required`)),
    vendor: yup.string().required(translate(`errorMessages.required`)),
    device_type: yup.string().required(translate(`errorMessages.required`)),
    name: yup
      .string()
      .required(translate(`errorMessages.required`))
      .test({
        name: 'unique-name',
        test(value, ctx) {
          const sameName = siteNames.includes(value);
          return sameName
            ? ctx.createError({
                message: translate(`${LOCALE_PREFIX}.device.quickMenu.sameNameError`),
              })
            : true;
        },
      }),
  });

  return {
    schema,
  };
};
